import { Injectable } from '@angular/core';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { TableFilter, TableQueryParams } from '../models/table.models';

@Injectable({
  providedIn: 'root',
})
export class TableQueryService {
  buildQueryParams(
    tableParams: NzTableQueryParams,
    currentParams: TableQueryParams
  ): TableQueryParams {
    const { pageSize, pageIndex, sort, filter } = tableParams;
    const currentSort = sort?.find(item => item.value !== null);

    return {
      ...currentParams,
      pageSize,
      pageIndex,
      sortField: currentSort?.key || currentParams.sortField,
      sortOrder: currentSort
        ? currentSort.value === 'ascend'
          ? 0
          : 1
        : currentParams.sortOrder,
      filters: this.processFilters(filter),
    };
  }

  private processFilters(filters: TableFilter[]): Record<string, unknown> {
    if (!filters?.length) return {};

    return filters.reduce(
      (acc, filter) => {
        if (filter.value) {
          acc[filter.key] = filter.value;
        }
        return acc;
      },
      {} as Record<string, unknown>
    );
  }
}
